<template>
    <div class="dib mb30 vat" :style="{width: (full ? 100 : (half ? 50 : width)) + '%'}" :class="{mr4: !half}">
        <p v-if="title" class="fs18 fw500" style="margin-bottom: 10px;">{{title}}</p>
        <!-- <p :class="$style.wrapper" :isSmall="isSmall" class="dflex">
            <span style="border-right: 1px solid rgb(185,185,185); padding: 0 8px;" class="dib" v-if="this.$slots.default"><slot></slot></span>
            <input type="text" class="f1" style="padding-left: 4px;" v-model="currentValue">
        </p> -->
        <p :class="$style.wrapper" :isSmall="isSmall" class="dflex noborder">
            <span style="border-right: 1px solid rgb(185,185,185); padding: 0 8px;" class="dib dflex" v-if="this.$slots.default"><slot></slot></span>
            <el-select v-model="currentValue" style="width:100%;" placeholder="" :popper-append-to-body="false">
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </p>
    </div>
</template>
<script>
export default {
    name: 'uselect',
    props: {
        title: { type: String, defualt: null},
        width: { type: Number, default: 45 },
        value: "",
        isSmall: { type: Boolean, default: false},
        options: {type: Array, default: () => {[]}},
        half: {type: Boolean, default: false}, //占满半个
        full: {type: Boolean, default: false}, //占满整行
    },
    data() {
        return {
            currentValue: this.value,
        }
    },
    watch: {
        value() {
            this.currentValue = this.value;
        },
        currentValue() {
            this.$emit("update:value", this.currentValue);
            this.$emit("input", this.currentValue);
        },
    }
}
</script>
<style scoped >
@media screen and (max-width: 770px) {
	/deep/ .el-select-dropdown {
		max-width: 380px !important;
	}
}
	
</style>
<style module>
.wrapper {
    border: 1px solid #f3b707e6;
    line-height: 2;
}
.wrapper[isSmall] {
    padding: 0px;
}
</style>
